import React from "react";
import styles from "./portfolioCompareChart.module.scss";
import { formatItalianNumber } from "utils/formatUtils";
import { useComparisonLabels } from "../ComparisonLabelsContext";

const PortfolioCompareChart = ({ data1, data2 }) => {
  const labels = useComparisonLabels();
  // Combine data for rendering
  const combinedData = data1.map((item1) => {
    const matchingItem = data2.find((item2) => item2.label === item1.label) || {
      weight: 0,
    };
    return {
      label: item1.label,
      value1: item1.weight,
      value2: matchingItem.weight,
    };
  });

  // Find the maximum value for scaling
  const maxValue = Math.max(
    ...combinedData.map((item) => Math.max(item.value1, item.value2)),
  );

  return (
    <div className={styles.chartContainer}>
      <div className={styles.chart}>
        <div className={styles.yAxisZeroLine}></div>
        <div>
          {combinedData.map((item, index) => (
            <div key={index} className={styles.chartItem}>
              <div className={styles.labelSection}>
                <span className={styles.label}>{item.label}</span>
              </div>

              <div className={styles.barSection}>
                {/* Portfolio 1 Bar */}
                <div className={styles.barContainer}>
                  <div
                    className={styles.bar1}
                    style={{ width: `${maxValue > 0 ? (item.value1 / maxValue) * 100 : 0}%` }}
                  ></div>
                  <span className={styles.barValue}>
                    {formatItalianNumber(item.value1)}%
                  </span>
                </div>

                {/* Portfolio 2 Bar */}
                <div className={styles.barContainer}>
                  <div
                    className={styles.bar2}
                    style={{ width: `${maxValue > 0 ? (item.value2 / maxValue) * 100 : 0}%` }}
                  ></div>
                  <span className={styles.barValue2}>
                    {formatItalianNumber(item.value2)}%
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* X-axis */}
      <div className={styles.xAxis}>
        <div className={styles.zeroLine}></div>
        <div className={styles.xAxisLine}></div>
        <div className={styles.xAxisLabels}>
          <span>0</span>
          <span>20,0</span>
          <span>40,0</span>
          <span>60,0</span>
          <span>80,0</span>
          <span>100,0</span>
        </div>
      </div>

      {/* Legend */}
      <div className={styles.legend}>
        <div className={styles.legendItem}>
          <span className={styles.legendColor1}></span>
          <span>{labels.portfolio1}</span>
        </div>
        <div className={styles.legendItem}>
          <span className={styles.legendColor2}></span>
          <span>{labels.portfolio2}</span>
        </div>
      </div>
    </div>
  );
};

export default PortfolioCompareChart;
